import $ from 'jquery';

const namespace = 'fluidfield';

export default class FluidField {
  constructor(el, options) {
    this.options = $.extend(
      true,
      {
        selectors: {
          input: 'input',
          label: 'label',
        },
        classes: {
          active: 'is-active',
        },
      },
      options,
    );

    this.$el = $(el);

    this.bind();
  }

  bind() {
    this.$el.on(
      `focus.${namespace}`,
      this.options.selectors.input,
      this.handleCheck.bind(this),
    );

    this.$el.on(
      `keyup.${namespace}`,
      this.options.selectors.input,
      this.handleCheck.bind(this),
    );

    this.$el.on(
      `change.${namespace}`,
      this.options.selectors.input,
      this.handleCheck.bind(this),
    );
  }

  /**
   * @param {Event} event
   */
  handleCheck(event) {
    const {currentTarget} = event;
    const $target = $(currentTarget);

    this.check($target);
  }

  /**
   * @param {jQuery} target
   */
  check(target) {
    if (target.val().length >= 1) {
      this.$el.addClass(this.options.classes.active);
      return;
    }

    this.$el.removeClass(this.options.classes.active);
  }
}
